import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';

import { ISearchTextHistoryProps } from './types';
import { SearchTextHistoryDesktop } from './SearchTextHistoryDesktop';
import { SearchTextHistoryMobile } from './SearchTextHistoryMobile';

export const SearchTextHistory: React.FC<ISearchTextHistoryProps> = props => {
  const isDesktop = useDeviceType() === 'desktop';

  return isDesktop ? <SearchTextHistoryDesktop {...props} /> : <SearchTextHistoryMobile {...props} />;
};

SearchTextHistory.displayName = 'SearchTextHistory';
